import { ref } from '@vue/composition-api';
import { warmUpService } from '@/bundles/WarmUp/factory/WarmUpServiceFactory';

export function useWarmups() {
  const warmUps = ref<any[]>([]);
  const total = ref(0);
  const pending = ref(false);

  async function fetch(params: any[]) {
    pending.value = true;
    const { data, total: warmUpTotal } = await warmUpService.list(params);
    warmUps.value = data;
    total.value = warmUpTotal;
    pending.value = false;
  }

  return {
    warmUps,
    total,
    pending,
    fetch,
  };
}
